import { Button, Col, Form, Row } from 'antd';
import { useCallback } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { ScheduleFormListItem } from './ScheduleFormListItem';
import { PlusOutlined } from '@ant-design/icons';

// const data = [
//   'Write a cool JS library',
//   'Make it generic enough',
//   'Write README',
// ];

// interface ScheduleFormListProps {
//   data: any;
// }

const ScheduleFormList = () => {
  // const reorder = (list, startIndex, endIndex) => {
  //   const result = Array.from(list);
  //   const [removed] = result.splice(startIndex, 1);
  //   result.splice(endIndex, 0, removed);

  //   return result;
  // };

  // function onDragEnd(result, move) {
  //   if (!result.destination) {
  //     return;
  //   }
  //   move(result.source.index, result.destination.index);
  //   const newQ = reorder(data, result.source.index, result.destination.index);

  //   // console.log(newQ);

  //   setData({ newQ });
  // }

  const onDragEnd = useCallback((result, move) => {
    if (!result.destination) {
      return;
    }
    move(result.source.index, result.destination.index);
  }, []);

  return (
    <Form.List name="list">
      {(fields, { add, move, remove }) => {
        return (
          <Form.Item>
            <DragDropContext onDragEnd={(result) => onDragEnd(result, move)}>
              <Droppable droppableId="list">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    <>
                      {fields.map((field, i) => (
                        // eslint-disable-next-line react/jsx-no-undef
                        <ScheduleFormListItem
                          quote={field}
                          index={i}
                          key={field.key}
                          remove={remove}
                        />
                      ))}
                      {/* <Form.Item>
                        <Button onClick={() => add()}>Add field</Button>
                      </Form.Item> */}
                      <Form.Item>
                        <Row justify={'center'}>
                          <Col span={12}>
                            <Button
                              type="dashed"
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined rev={undefined} />}
                            >
                              추가
                            </Button>
                          </Col>
                        </Row>
                      </Form.Item>
                    </>
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Form.Item>
        );
      }}
    </Form.List>
  );
};

export default ScheduleFormList;
